module.exports = __webpack_public_path__ + "img/chanel.52ecbdfa.png";